﻿const requirePlugin = require.context('.', false, /.js$/);
let plugins = [];

requirePlugin.keys().forEach(filename => {
    if (filename.endsWith('/index.js') === false) {
        const plugin = requirePlugin(filename);
        plugins.push(plugin.default || plugin);
    }
});

export default plugins;